import { render, staticRenderFns } from "./BoolSelect.vue?vue&type=template&id=af9fcb3a&"
import script from "./BoolSelect.vue?vue&type=script&lang=js&"
export * from "./BoolSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports